import PageNotFoundScreen from '../screens/404'

export default PageNotFoundScreen
